module.exports = __webpack_public_path__ + "static/media/post.72caa65d.svg";